module.exports = __webpack_public_path__ + "img/potted-flower-tulip.84a26be6.svg";